/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type MarkAsResolvedButtonAlert_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type MarkAsResolvedButtonAlert_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_StopAccessibilityDownvotedByDrivers_Fragment =
  {
    __typename?: 'StopAccessibilityDownvotedByDrivers'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type MarkAsResolvedButtonAlert_StopActivationFailedNotification_Fragment =
  {
    __typename?: 'StopActivationFailedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type MarkAsResolvedButtonAlert_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type MarkAsResolvedButtonAlert_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_TripPrebookingNoAssignment_Fragment = {
  __typename?: 'TripPrebookingNoAssignment'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_VehicleAvailabilityNotification_Fragment =
  {
    __typename?: 'VehicleAvailabilityNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type MarkAsResolvedButtonAlert_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlert_VehicleSurveillanceNotification_Fragment =
  {
    __typename?: 'VehicleSurveillanceNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type MarkAsResolvedButtonAlert_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  id: string
  notificationType: Types.TaskNotificationType
}

export type MarkAsResolvedButtonAlertFragment =
  | MarkAsResolvedButtonAlert_HubServiceNotification_Fragment
  | MarkAsResolvedButtonAlert_IvcTaskNotification_Fragment
  | MarkAsResolvedButtonAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | MarkAsResolvedButtonAlert_PassengerUnbuckled_Fragment
  | MarkAsResolvedButtonAlert_RoadBlockageTaskNotification_Fragment
  | MarkAsResolvedButtonAlert_ShiftDeviationNotification_Fragment
  | MarkAsResolvedButtonAlert_StopAccessibilityDownvotedByDrivers_Fragment
  | MarkAsResolvedButtonAlert_StopActivationFailedNotification_Fragment
  | MarkAsResolvedButtonAlert_StopAreaMissingActiveStopsNotification_Fragment
  | MarkAsResolvedButtonAlert_StopDownVotedByDrivers_Fragment
  | MarkAsResolvedButtonAlert_StopPotentiallyUnreachable_Fragment
  | MarkAsResolvedButtonAlert_StopValidationFailed_Fragment
  | MarkAsResolvedButtonAlert_TimeManagementNotification_Fragment
  | MarkAsResolvedButtonAlert_TripPrebookingNoAssignment_Fragment
  | MarkAsResolvedButtonAlert_VehicleAvailabilityNotification_Fragment
  | MarkAsResolvedButtonAlert_VehicleIncidentNotification_Fragment
  | MarkAsResolvedButtonAlert_VehicleSurveillanceNotification_Fragment
  | MarkAsResolvedButtonAlert_VehicleWaypointAttendance_Fragment

export const MarkAsResolvedButtonAlertFragmentDoc = gql`
    fragment MarkAsResolvedButtonAlert on TaskNotification {
  id
  notificationType
}
    `
